<template>
  <div>
    <!-- {{ rxAndAccom[eye].accommodation }} -->
    <v-card
      class="mt-2 pr-4 width100p relative"
      :class="[eye + 'Background', eye + 'Border']"
      flat
    >
      <!-- {{ expanded }} -->
      <!-- <v-expand-transition> -->

      <v-container no-gutters class="ma-0 pa-0">
        <v-row no-gutters align="center">
          <v-col
            cols="8"
            :sm="shouldMagnify ? 8 : 10"
            class="blurImageContainer"
          >
            <blur-image
              class="ma-2 blurImage"
              :style="imageStyle"
              :size="isMobile ? 80 : 140"
              :image="lookingAt"
              :uncorrectedRx="rxAndAccom[eye].rx"
              :eye="eye"
              :showVA="true"
            ></blur-image>
            <!-- </div> --> </v-col
          ><v-col cols="4" :sm="shouldMagnify ? 4 : 2">
            <div
              style="position: absolute; top: 0; right: 0; z-index: 10"
              class="d-flex flex-row align-center"
            >
              <v-btn
                v-if="$vuetify.breakpoint.smAndUp"
                icon
                @click="doMagnify = !doMagnify"
                class="mr-1"
              >
                <v-icon small color="primary"
                  >mdi-{{
                    shouldMagnify ? "arrow-collapse" : "magnify"
                  }}</v-icon
                >
              </v-btn>
              <vs-eye-more-info
                :eye="eye"
                :rx="rxAndAccom[eye].rx"
                :accommodation="rxAndAccom[eye].accommodation"
                :maxAccom="accomAbility"
                :correctionType="correctionType"
                :lookingAt="lookingAt"
                :correctionText="correctionText"
                :uncorrectedRx="rxs[eye]"
              ></vs-eye-more-info>
            </div>
            <vs-eye
              :style="`width: ${eyeStyleWidth}px`"
              :size="eyeSize"
              :eye="eye"
              :uncorrectedRx="rxAndAccom[eye].rx"
              :accommodation="rxAndAccom[eye].accommodation"
              :maxAccom="accomAbility"
              :correctiveLens="correctionType"
            ></vs-eye>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <slot></slot>
  </div>
</template>

<script>
import VsEye from "./VsEye.vue";
import VsEyeMoreInfo from "./VsEyeMoreInfo.vue";
import BlurImage from "./BlurImage.vue";
import RxMethods from "@/assets/js/cls/RxMethods";
import VsDefinitions from "./VsDefinitions";

export default {
  name: "ImageAndEyeRow",
  components: {
    VsEye,
    BlurImage,
    VsEyeMoreInfo,
  },
  mixins: [RxMethods],
  props: {
    eye: { type: String, default: "od" },
    // target: { type: String, default: "far" },
    rxs: null,
    // targetDiopters: { type: Number, default: 0 },
    lookingAt: { type: String, default: "far" },
    accomAbility: { type: Number, default: 0 }, // the max accommodation ability
    yokedAccommodation: null,
    correctionType: null,
    correctionText: null,
    // expanded: null,
  },
  data: function () {
    return {
      accommodation: 0,
      followWithSpacer: ["far", "wall"],
      doMagnify: false,
    };
  },
  methods: {},
  computed: {
    isMobile: function () {
      //console.log(this.$vuetify.breakpoint);
      return this.$vuetify.breakpoint.xs;
    },
    targetArr: function () {
      return Object.keys(this.targets);
    },
    rxAndAccom: function () {
      let rtn = {};
      // this.targetArr.forEach((target) => {
      rtn = this.rxAfterAccommodation(
        this.rxs,
        this.lookingAtObject.diopters,
        this.accomAbility,
        this.yokedAccommodation
      );
      // });
      return rtn;
    },
    shouldMagnify: function () {
      return this.doMagnify && this.$vuetify.breakpoint.smAndUp;
    },

    // imagesToShow: function () {
    //   return this.isMobile ? [this.lookingAt_internal] : this.imageKeys;
    // },
    imageKeys: function () {
      return Object.keys(this.images);
    },
    images: function () {
      return VsDefinitions.lookingAtData;
    },
    imageStyle: function () {
      let left = this.images[this.lookingAt].left;
      return {
        left: `${left}%`,
        top: 0,
      };
    },
    lookingAtObject: function () {
      return VsDefinitions.lookingAtData[this.lookingAt];
    },
    eyeSize: function () {
      let rtn = this.isMobile ? 80 : 140;
      if (this.shouldMagnify) rtn = 270;
      return rtn;
    },
    eyeStyleWidth: function () {
      let rtn = this.isMobile ? 130 : 180 * 1.3;

      // if (this.expanded) rtn *= 2;
      return rtn;
    },
  },
  watch: {
    // lookingAt(val) {
    //   if (val) this.lookingAt_internal = val;
    // },
  },
};
</script>

<style scoped>
.sidewaysText {
  writing-mode: vertical-lr;
  text-orientation: upright;
}
.blurImageContainer {
  position: relative;
}
.blurImage {
  position: relative;
  transform: translate(-50%);
  max-width: 100px;
}
.disappear {
  display: none;
}
</style>
